var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"admin"},[_c('div',{staticClass:"info-table"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[(_vm.hideWhen)?_c('Nav'):_vm._e(),_c('router-view')],1)])])])])}
var staticRenderFns = []

export { render, staticRenderFns }